module.exports = __webpack_public_path__ + "static/media/uk.88277e60.png";